import { render, staticRenderFns } from "./CategoryCarousel.vue?vue&type=template&id=1e1acb09&scoped=true"
import script from "./CategoryCarousel.vue?vue&type=script&lang=js"
export * from "./CategoryCarousel.vue?vue&type=script&lang=js"
import style0 from "./CategoryCarousel.vue?vue&type=style&index=0&id=1e1acb09&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1acb09",
  null
  
)

export default component.exports